import script from "./SearchInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchInput.vue?vue&type=script&lang=ts&setup=true"

import "./SearchInput.vue?vue&type=style&index=0&id=223dd4f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223dd4f4"]])

export default __exports__